(function() {
    'use strict';

    angular
        .module('nasracApp')
        .controller('SecurityRolesDetailController', SecurityRolesDetailController);

    SecurityRolesDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity','DTColumnBuilder', 'DTOptionsBuilder',  'GUIUtils', '$filter', '$compile', 'AuthServerProvider', 'Principal', 'SecurityRoles'];

    function SecurityRolesDetailController($scope, $rootScope, $stateParams, previousState, entity,DTColumnBuilder, DTOptionsBuilder, GUIUtils, $filter, $compile, AuthServerProvider, Principal, SecurityRoles) {
        var vm = this;

        vm.securityRoles = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('nasracApp:securityRolesUpdate', function(event, result) {
            vm.securityRoles = result;
        });
        $scope.$on('$destroy', unsubscribe);

        vm.nasracPackages = {
            createRoles: "Administrators,DAC Content Administrator"
        };

        vm.dtOptions = DTOptionsBuilder.newOptions()
            .withDOM(
                "<'row'<'col-sm-3'l><'col-sm-6 text-center'B><'col-sm-3'f>>" +
                "<'row'<'col-sm-12'tr>>" +
                "<'row'<'col-sm-5'i><'col-sm-7'p>>")
            .withDataProp('data') // This is the name of the value in the returned recordset which contains the actual data
            .withOption('serverSide', true)
            .withBootstrapOptions({
                TableTools: {
                    classes: {
                        container: 'btn-group',
                        buttons: {
                            normal: 'btn btn-danger'
                        }
                    }
                },
                ColVis: {
                    classes: {
                        masterButton: 'btn btn-primary'
                    }
                },
                pagination: {
                    classes: {
                        ul: 'pagination pagination-sm'
                    }
                }
            })
            .withPaginationType('full_numbers')
    .withButtons([
            {
                text: 'Export',
                extend: "excelHtml5",
                title:"Nasrac Sources",
                action: function (e, dt, node, config) {
                    NasracPackage.download().$promise
                        .then(function (data) {
                            var url = URL.createObjectURL(data.response);
                            var link = document.createElement("a");
                            link.href = url;

                            //set the visibility hidden so it will not effect on your web-layout
                            link.style = "visibility:hidden";
                            link.download = "NAS-RAC_Packages.xlsx"; //this is an example file to download, use yours

                            //this part will append the anchor tag and remove it after automatic click
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link);
                        });
                },
                exportOptions: {
                    columns: ':visible'
                },
                //CharSet: "utf8",
                exportData: { decodeEntities: true }
            }
        ])

            .withDisplayLength(25)

            .withOption('createdRow', function (row) {
                // Recompiling so we can bind Angular directive to the DT
                $compile(angular.element(row).contents())($scope);
            })
            .withOption('saveState', true)
            .withOption('order', [1, 'asc'])
            .withOption("lengthMenu", [[10, 25, 50, -1], [10, 25, 50, "All"]]);
        vm.dtColumns = [
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '155px').notSortable()
                .renderWith(actionsHtml),
            DTColumnBuilder.newColumn('packageBsgHandle').withTitle('Package Bsg Handle'),
            DTColumnBuilder.newColumn('id').withTitle('Package Id'),
            DTColumnBuilder.newColumn('packageName').withTitle('Package Name')
        ];

        if (Principal.hasAnyAuthority(['DAC Content User'])){
            vm.dtColumns[0].visible = false;
        }


        function actionsHtml(data, type, full, meta){
            return GUIUtils.getActionsTemplate(data, $state.current.name, ['update','delete']);
        }



    }
})();
